import React, { useEffect, useState } from 'react';
import FcModuleStyle from '../styles/fc.module.css';
import Highcharts from 'highcharts';
require('highcharts/modules/accessibility')(Highcharts);

const ActualDemandGraph = ({ type, isDecisionPopup, showDecisionPopupHandler, hideDecisionPopupHandler, simObj, setSimObj, isResult, summaryGraphData, attempt }) => {

  const [RevenueData, setRevenueData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [CostsData, setCostsData] = useState({ "monthly": [], "quarterly": [], "yearly": [] });
  const [xAxisMinMax, setXAxisMinMax] = useState({ "monthly": { min: 1, max: 31 }, "quarterly": { min: 0, max: 3 }, "yearly": { min: 0, max: 12 } });
  const [dpObject, setDpObject] = useState({});
  const [isShowD, setIsShowD] = useState(true);
  const [revenueGraphLabel, setRevenueGraphLabel] = useState("");
  const [chart, setChart] = useState(null);
  const [isOptionsUpdated,setIsOptionsUpdated] = useState(false)

  let graphSettings = {}
  function getMonthDays(year, month) {
    // Months are 0-based in JavaScript (0 - January, 1 - February, ..., 11 - December)
    const lastDay = new Date(year, month, 0);
    return lastDay.getDate();
  }
  const getDate = (date) => {
    let formattedDate;
    let dateObject = new Date(date);
    let options = { year: 'numeric', month: 'long', day: 'numeric' };
    if (navigator.userAgent.indexOf('iPhone') > -1) {
      dateObject = new Date(date.replace(/-/g, "/"));
    }
    return dateObject.toLocaleDateString(navigator.language, options);
  }
  // let RevenueData = {
  //   "monthly": [],
  //   "yearly": [],
  //   "quarterly": []
  // }
  // let CostsData = {
  //   "monthly": [],
  //   "yearly": [],
  //   "quarterly": []
  // }
  /*
  const setGraphData = () => {
    if (chart != undefined) {
      let revenueMonthlyData = [];
      let revenueQuarterlyData = [];
      let revenueYearlyData = [];
      let costMonthlyData = [];
      let costQuaerterlyData = [];
      let costYearlyData = [];
      let monthDays = 0;
      let newPoint = "";
      let existingData = "";
      let newData = "";
      let date = new Date();
      chart?.yAxis != undefined && chart?.yAxis[0]?.update({ min: 0, max: undefined });
      switch (type) {
        case "monthly":
          revenueMonthlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.statemonth === simObj.laststate.statemonth) {
              return true;
            }
          });
          revenueMonthlyData = (revenueMonthlyData != undefined ? revenueMonthlyData : []).map((data) => {
            return {
              x: data.stateday,
              y: data.revenue,
              date: getDate(data.currentRampDate),
              revenue: data.revenue,
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            monthly: revenueMonthlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            monthly: { min: 1, max: new Date(date.getFullYear(), date.getMonth(), 0).getDate() }
          }));
          if (chart?.series != undefined && revenueMonthlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueMonthlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            // newData = [...existingData, revenueMonthlyData[revenueMonthlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueMonthlyData[revenueMonthlyData.length - 1].x) {
                  existingData[index] = revenueMonthlyData[revenueMonthlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueMonthlyData[revenueMonthlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }
          (revenueMonthlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          //Cost Data
          costMonthlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.statemonth === simObj.laststate.statemonth) {
              return true;
            }
          });
          costMonthlyData = (costMonthlyData != undefined ? costMonthlyData : []).map((data) => {
            return {
              x: data.stateday,
              y: data.cost,
              cost: Math.round(data.cost),
              date: getDate(data.currentRampDate),
              costOfInternalFailures: Math.round(data.costOfInternalFailures),
              costOfExternalFailures: data.conceptualCostOfExternalFailures,
              costOfPreventiveInvestment: data.costOfPreventiveInvestment,
              costOfAppraisal: data.costOfAssessmentInvestment,
              costOfotherInvestment: data.costOfRedHerringInvestment
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            monthly: costMonthlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            monthly: { min: 1, max: new Date(date.getFullYear(), date.getMonth(), 0).getDate() }
          }));

          if (chart?.series != undefined && costMonthlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costMonthlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[1]?.options?.data : [];
            // newData = [...existingData, costMonthlyData[costMonthlyData.length - 1]];

            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costMonthlyData[costMonthlyData.length - 1].x) {
                  existingData[index] = costMonthlyData[costMonthlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costMonthlyData[costMonthlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[1]?.setData(newData);
          }
          (simObj?.laststate?.stateyear != undefined && simObj?.laststate?.statemonth != undefined) && (chart?.xAxis != undefined) && chart?.xAxis[0]?.update({ min: 1, max: getMonthDays(simObj.laststate.stateyear, simObj.laststate.statemonth) });
          (costMonthlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "quarterly":
          revenueQuarterlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.statemonth >= simObj.laststate.statemonth - 2) {
              return true;
            }
          });
          revenueQuarterlyData = (revenueQuarterlyData != undefined ? revenueQuarterlyData : []).map((data) => {
            return {
              x: ((data.statemonth - 1) + (data.stateday / getMonthDays(simObj.laststate.stateyear, data.statemonth))),
              y: data.revenue,
              date: getDate(data.currentRampDate),
              revenue: data.revenue,

            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            quarterly: revenueQuarterlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            quarterly: { min: simObj.laststate.statemonth - 3, max: simObj.laststate.statemonth }
          }));

          if (chart?.series != undefined && revenueQuarterlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueQuarterlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            // newData = [...existingData, revenueQuarterlyData[revenueQuarterlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueQuarterlyData[revenueQuarterlyData.length - 1].x) {
                  existingData[index] = revenueQuarterlyData[revenueQuarterlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueQuarterlyData[revenueQuarterlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }

            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }

          (revenueQuarterlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });

          //Cost Data
          costQuaerterlyData = simObj?.graphdata?.filter((data, index) => {
            if (data.statemonth >= simObj.laststate.statemonth - 2) {
              return true;
            }
          });
          costQuaerterlyData = (costQuaerterlyData != undefined ? costQuaerterlyData : []).map((data) => {
            return {
              x: ((data.statemonth - 1) + (data.stateday / getMonthDays(simObj.laststate.stateyear, data.statemonth))),
              y: data.cost,
              cost: Math.round(data.cost),
              date: getDate(data.currentRampDate),
              costOfInternalFailures: Math.round(data.costOfInternalFailures),
              costOfExternalFailures: data.conceptualCostOfExternalFailures,
              costOfPreventiveInvestment: data.costOfPreventiveInvestment,
              costOfAppraisal: data.costOfAssessmentInvestment,
              costOfotherInvestment: data.costOfRedHerringInvestment
            }
          });
          setCostsData(prevData => ({
            ...prevData,
            quarterly: costQuaerterlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            quarterly: { min: simObj?.laststate?.statemonth - 3, max: simObj?.laststate?.statemonth }
          }));

          if (chart?.series != undefined && costQuaerterlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costQuaerterlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[1]?.options?.data : [];
            // newData = [...existingData, costQuaerterlyData[costQuaerterlyData.length - 1]];

            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costQuaerterlyData[costQuaerterlyData.length - 1].x) {
                  existingData[index] = costQuaerterlyData[costQuaerterlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costQuaerterlyData[costQuaerterlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            chart?.series != undefined && chart?.series[1]?.setData(newData);
          }
          // if ((simObj?.laststate?.statemonth - 1) % 3 == 0) {
          //   chart?.xAxis[0]?.update({
          //     min: simObj.laststate.statemonth - 1,
          //     max: simObj.laststate.statemonth + 2
          //   });
          // }
          let min = 0, max = 0;
          if (simObj?.laststate?.statemonth / 3 >= 0 && simObj?.laststate?.statemonth / 3 <= 1) {
            min = 0;
            max = 3;
          }
          else if (simObj?.laststate?.statemonth / 3 > 1 && simObj?.laststate?.statemonth / 3 <= 2) {
            min = 3;
            max = 6;
          }
          else if (simObj?.laststate?.statemonth / 3 > 2 && simObj?.laststate?.statemonth / 3 <= 3) {
            min = 6;
            max = 9;
          }
          else if (simObj?.laststate?.statemonth / 3 > 3 && simObj?.laststate?.statemonth / 3 <= 4) {
            min = 9;
            max = 12;
          }
          (chart?.xAxis != undefined) && chart?.xAxis[0]?.update({
            // min: simObj.laststate.statemonth-1,
            // max: simObj.laststate.statemonth+2
            min: min,
            max: max
          });
          (costQuaerterlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        case "yearly":
          revenueYearlyData = simObj?.graphdata;
          revenueYearlyData = (revenueYearlyData != undefined ? revenueYearlyData : []).map((data) => {
            return {
              x: ((data.statemonth - 1) + (data.stateday / getMonthDays(simObj.laststate.stateyear, data.statemonth))),
              y: data.revenue,
              date: getDate(data.currentRampDate),
              revenue: data.revenue,
            }
          });
          setRevenueData(prevData => ({
            ...prevData,
            yearly: revenueYearlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            yearly: { min: 0, max: 12 }
          }));

          if (chart?.series != undefined && revenueYearlyData.length != chart?.series[0]?.data?.length) {
            chart?.series[0]?.setData(revenueYearlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[0]?.options?.data : [];
            // newData = [...existingData, revenueYearlyData[revenueYearlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == revenueYearlyData[revenueYearlyData.length - 1].x) {
                  existingData[index] = revenueYearlyData[revenueYearlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, revenueYearlyData[revenueYearlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[0]?.setData(newData);
          }
          (revenueYearlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          //Cost Data
          costYearlyData = simObj?.graphdata;
          costYearlyData = (costYearlyData != undefined ? costYearlyData : []).map((data) => {
            return {
              x: ((data.statemonth - 1) + (data.stateday / getMonthDays(simObj.laststate.stateyear, data.statemonth))),
              y: data.cost,
              cost: Math.round(data.cost),
              date: getDate(data.currentRampDate),
              costOfInternalFailures: Math.round(data.costOfInternalFailures),
              costOfExternalFailures: data.conceptualCostOfExternalFailures,
              costOfPreventiveInvestment: data.costOfPreventiveInvestment,
              costOfAppraisal: data.costOfAssessmentInvestment,
              costOfotherInvestment: data.costOfRedHerringInvestment
            }
          });

          setCostsData(prevData => ({
            ...prevData,
            yearly: costYearlyData
          }));

          setXAxisMinMax(prevData => ({
            ...prevData,
            yearly: { min: 0, max: 12 }
          }));

          if (chart?.series != undefined && costYearlyData.length != chart?.series[1]?.data?.length) {
            chart?.series[1]?.setData(costYearlyData);
          }
          else {
            // Get the existing data and add the new point
            existingData = chart?.series != undefined ? chart?.series[1]?.options?.data : [];
            // newData = [...existingData, costYearlyData[costYearlyData.length - 1]];
            let found = false;
            existingData.forEach((element, index) => {
              if (element != undefined) {
                if (element.x == costYearlyData[costYearlyData.length - 1].x) {
                  existingData[index] = costYearlyData[costYearlyData.length - 1]
                  found = true;
                }
              }
            });
            if (!found) {
              newData = [...existingData, costYearlyData[costYearlyData.length - 1]];
            }
            else {
              newData = [...existingData]
            }
            // Update the series data with the new data
            chart?.series != undefined && chart?.series[1]?.setData(newData);
          }
          (chart?.xAxis != undefined) && chart?.xAxis[0]?.update({
            min: 0,
            max: 12
          });
          (costYearlyData.length == 0 && simObj?.graphdata != undefined && simObj?.graphdata.length == 0) && chart?.yAxis[0]?.update({ min: 1, max: 125 });
          break;
        default:
          break;
      }
      // setDataLabel((simObj?.graphdata != undefined) ? simObj?.graphdata : []);
    }
  }*/


  // const xAxis = {
  //   "monthly": {
  //     min: xAxisMinMax[type].min,
  //     max: xAxisMinMax[type].max,
  //     color: 'rgb(242,242,242)',
  //     lineColor: '#C6C6C3',
  //     gridLineWidth: 1,
  //     gridZIndex: 4,
  //     tickInterval: 1,
  //     tickLength: 0,
  //     crosshair: {
  //       snap: false,
  //       width: 1,
  //       color: '#C9C8B9',
  //       zIndex: 5
  //     },
  //     accessibility: {
  //       point: {

  //       }
  //     },
  //     title: {
  //       text: "Day of Month",
  //       style: {
  //         fontWeight: 'bold',
  //         fontSize: '12px',
  //         color: "#000"
  //       }
  //     },
  //     labels: {
  //       rotation: 0,
  //       step: 1,
  //       style: {
  //         fontSize: '0.6em'
  //       }
  //     }

  //   },
  //   "quarterly": {
  //     categories: ['', 'January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  //     min: xAxisMinMax[type].min,
  //     max: xAxisMinMax[type].max,
  //     // max:3,
  //     tickmarkPlacement: 'on',
  //     color: 'rgb(242,242,242)',
  //     lineColor: '#C6C6C3',
  //     gridLineWidth: 1,
  //     gridZIndex: 4,
  //     tickInterval: 1,
  //     tickLength: 0,
  //     title: {
  //       text: "Month",
  //       style: {
  //         fontWeight: 'bold',
  //         fontSize: '12px',
  //         color: "#000"
  //       }
  //     },
  //     rangeSelector: {
  //       selected: 1
  //     },
  //     accessibility: {
  //       point: {

  //       }
  //     },
  //     crosshair: {
  //       snap: false,
  //       width: 1,
  //       color: '#C9C8B9',
  //       zIndex: 5
  //     }
  //   },
  //   "yearly": {
  //     min: xAxisMinMax[type].min,
  //     max: xAxisMinMax[type].max,
  //     color: 'rgb(242,242,242)',
  //     lineColor: '#C6C6C3',
  //     gridLineWidth: 1,
  //     gridZIndex: 4,
  //     tickInterval: 3,
  //     tickLength: 0,
  //     title: {
  //       text: "Quarter",
  //       style: {
  //         fontWeight: 'bold',
  //         fontSize: '12px',
  //         color: "#000"
  //       }
  //     },
  //     accessibility: {
  //       point: {

  //       }
  //     },
  //     categories: ['', '', '', 'Q1', '', '', 'Q2', '', '', 'Q3', '', '', 'Q4'],
  //     tickmarkPlacement: 'on',
  //     crosshair: {
  //       snap: false,
  //       width: 1,
  //       color: '#C9C8B9',
  //       zIndex: 5
  //     }
  //   }
  // }
  // const yAxis = {
  //   "monthly": {
  //     //min: 0,
  //     // max: 10000000,
  //     // offset: -10,
  //     maxPadding: 0.1,
  //     tickInterval: null,
  //     tickAmount: 6,
  //     startOnTick: true,
  //     color: 'rgb(255,255,255)',
  //     title: {
  //       text: "Revenue/Cost of Quality",
  //       style: {
  //         fontWeight: 'bold',
  //         fontSize: '10px',
  //         color: "#000"
  //       }
  //     },
  //     // tickInterval: 2000000,
  //     gridLineWidth: 0,
  //     labels: {
  //       formatter: function () {
  //         return Highcharts.numberFormat(this.value, 0, ',', ',');
  //       }

  //     },

  //   },
  //   "quarterly": {
  //     //min: 0,
  //     // max: 10000000,
  //     maxPadding: 0.1,
  //     tickInterval: null,
  //     startOnTick: true,
  //     tickAmount: 6,
  //     color: 'rgb(255,255,255)',
  //     title: {
  //       text: "Revenue/Cost of Quality",
  //       style: {
  //         fontWeight: 'bold',
  //         fontSize: '10px',
  //         color: "#000"
  //       }
  //     },
  //     // tickInterval: 2000000,
  //     gridLineWidth: 0,
  //     labels: {
  //       formatter: function () {
  //         return Highcharts.numberFormat(this.value, 0, ',', ',');
  //       }
  //     }
  //   },
  //   "yearly": {
  //     //min: 0,
  //     // max: 10000000,
  //     maxPadding: 0.1,
  //     tickInterval: null,
  //     tickAmount: 6,
  //     startOnTick: true,
  //     title: {
  //       text: "Revenue/Cost of Quality",
  //       style: {
  //         fontWeight: 'bold',
  //         fontSize: '10px',
  //         color: "#000"
  //       }
  //     },
  //     // tickInterval: 2000000,
  //     gridLineWidth: 0,
  //     labels: {
  //       formatter: function () {
  //         return Highcharts.numberFormat(this.value, 0, ',', ',');
  //       }
  //     }

  //   }
  // }
  let seriesData = {
    "REGULAR" : {
      name: 'Regular',
      data: [],
      color: '#044E61'
    },
    "MIDGRADE":{
      name: 'Midgrade',
      data: [],
      color: '#1A83CF'
    },
    "PREMIUM":{
      name: 'Premium',
      data: [],
      color: '#069161'
    }
  }
  graphSettings = {
    chart: {
      type: 'line',
      events: {
        render: function () {
          const svg = this.container.querySelector('svg');
          if (svg) {
            // Collect series names that are visible
            const visibleSeries = this.series
              .filter(s => s.visible)
              .map(s => s.name);

            const categories = this.xAxis[0].categories || [];

            const ariaLabel = `Actual demand graph showing ${visibleSeries.join(', ')} demand across ${categories[0]} to ${categories[categories.length - 1]}.`;
            svg.setAttribute('role', 'img');
            svg.setAttribute('aria-label', ariaLabel);

            let descText = `This graph represents actual demand for ${visibleSeries.join(', ')} types across the months ${categories.join(', ')}. `;

            visibleSeries.forEach(series => {
              const s = this.series.find(x => x.name === series);
              if (s) {
                const values = s.points.map(p => p.y);
                const min = Math.min(...values);
                const max = Math.max(...values);
                descText += `${series} demand ranges between ${min} and ${max}. `;
              }
            });

            let desc = svg.querySelector('desc');
            if (!desc) {
              desc = document.createElementNS('http://www.w3.org/2000/svg', 'desc');
              svg.insertBefore(desc, svg.firstChild);
            }
            desc.textContent = descText.trim();
          }
        }
      },
      zooming: {
        mouseWheel: false
      },
      height:200
    },
    plotOptions: {
      events: {
        legendItemClick: function () {
          return false; // Prevent default legend item click behavior
        }
      },
      series: {
        stickyTracking: true,
        marker: {
          enabled: true,
        },
        pointPlacement: "on",
        states: {
          inactive: {
            enabled: false
            //opacity:1
          },
          hover: {
            halo: {
              size: 7,
              opacity: 0.5,
            },

          }
        }
      }
    },
    credits: {
      enabled: false
    },
    accessibility: {
      enabled: true,
      pointDescriptionFormatter: function (point) {
        const monthMap = {
          'Jan': 'January',
          'Feb': 'February',
          'Mar': 'March',
          'Apr': 'April',
          'May': 'May',
          'Jun': 'June',
          'Jul': 'July',
          'Aug': 'August',
          'Sept': 'September',
          'Oct': 'October',
          'Nov': 'November',
          'Dec': 'December'
          };
          return `${monthMap[point.category]}, ${point.series.name}: ${point.y}`;
      },
      description: '',
      keyboardNavigation: {
        enabled: true, // Enable keyboard navigation
      } 
    },
    title: {
      text: ''
    },

    legend: {
      layout: 'vertical',
      align: 'right',
      verticalAlign: 'top',
      y: 50,
      padding: 3,
      itemMarginTop: 5,
      itemMarginBottom: 5,
      itemStyle: {
        lineHeight: '14px'
      }
    },

    xAxis: {
      min: 0,
      max: 5,
      tickLength: 0,
      categories: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'],
      title: {
        text: "Month Range",
        style: {
          fontWeight: 'bold',
          fontSize: '12px',
          color: "#000"
        }
      },
      rangeSelector: {
        selected: 1
      },
      labels: {
        rotation: -45
      },
      lineWidth: 1,
      lineColor: '#C6C6C3',
      crosshair: {
        width: 1,
        color: '#C9C8B9'
      }
    },
    yAxis: {
      min: 0,
      max: 15e3,
     

      maxPadding: 0.1,
      tickInterval: 5e3,
      //tickInterval: null,
      tickAmount: 4,
      startOnTick: true,
      title: {
        text: "Demand",
        style: {
          fontWeight: 'bold',
          fontSize: '10px',
          color: "#000"
        }
      },
      labels: {
        formatter: function () {
          var valueInK = this.value / 1000; // Convert value to thousands
          if (valueInK >= 1) {
            return Highcharts.numberFormat(valueInK, 0, ',', ',') + 'K'; // Format with 'K' for thousands
          }
          return this.value; // Display values less than 1000 without 'K'
        }
      }

    },
    series: undefined,
    tooltip: {
      hideDelay: 0,
      shared: true,
      formatter: function () {
        var monthMap = {
          'Jan': 'January',
          'Feb': 'February',
          'Mar': 'March',
          'Apr': 'April',
          'May': 'May',
          'Jun': 'June',
          'Jul': 'July',
          'Aug': 'August',
          'Sept': 'September',
          'Oct': 'October',
          'Nov': 'November',
          'Dec': 'December'
          };
          var fullMonthName = monthMap[this.x] || this.x;
        return '<strong>' + fullMonthName + '</strong><br/>' +
        this.points.map(point => '<span style="color:' + point.color + ';">●</span> ' + point.series.name + ': <strong>' + Highcharts.numberFormat(point.y, 0, ',', ',') + '</strong>').join('<br>');
      },
      /*borderWidth: 1,
      formatter: function () {
        var monthMap = {
        'Jan': 'January',
        'Feb': 'February',
        'Mar': 'March',
        'Apr': 'April',
        'May': 'May',
        'Jun': 'June',
        'Jul': 'July',
        'Aug': 'August',
        'Sept': 'September',
        'Oct': 'October',
        'Nov': 'November',
        'Dec': 'December'
        };
        var fullMonthName = monthMap[this.x] || this.x;
        var tooltipText = '<strong>' + fullMonthName + '</strong><br/>';
        if (this.series.name === 'Regular') {
          tooltipText += '<span style="color:#C5761C;">●&nbsp;</span>' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
        } else if (this.series.name === 'Midgrade') {
          tooltipText += '<span style="color:#544FC5;">●&nbsp;</span>' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
        } else if (this.series.name === 'Premium') {
          tooltipText += '<span style="color:#D568FB;">●&nbsp;</span>' + this.series.name + '</span>: <strong style="font-weight: bold;">' + Highcharts.numberFormat(this.y, 0, ',', ',') + '</strong>';
        }
        return tooltipText;
      }*/
    }
  }


  useEffect(() => {
    if(simObj?.lastSixMonthsDemands && simObj?.optionsAvailable && !isOptionsUpdated){
    let seriesdata = []
    for (const key in simObj?.optionsAvailable) {
      if (simObj?.optionsAvailable[key]) {
        seriesdata = [...seriesdata,seriesData[key]]
      }
    }
    graphSettings.series = seriesdata
    const newChart = Highcharts.chart("ActualDemandGraph", graphSettings);
    const lastSixMonthsDemands = simObj?.lastSixMonthsDemands;

    // Check if lastSixMonthsDemands is defined and is an array
    const REGULAR = [...(Array.isArray(lastSixMonthsDemands) ?
      lastSixMonthsDemands.flatMap(demand =>
        Object.keys(demand).map(key => demand[key]?.['REGULAR'] || [])
      ) : [])];
    newChart.series[0].setData(REGULAR);

    if(simObj?.optionsAvailable?.MIDGRADE){
      const MIDGRADE = [...(Array.isArray(lastSixMonthsDemands) ?
        lastSixMonthsDemands.flatMap(demand =>
          Object.keys(demand).map(key => demand[key]?.['MIDGRADE'] || [])
        ) : [])];
      newChart.series[1].setData(MIDGRADE);
    }

    if(simObj?.optionsAvailable?.PREMIUM){
    const PREMIUM = [...(Array.isArray(lastSixMonthsDemands) ?
      lastSixMonthsDemands.flatMap(demand =>
        Object.keys(demand).map(key => demand[key]?.['PREMIUM'] || [])
      ) : [])];
    newChart.series[2].setData(PREMIUM);
  }
    setChart(newChart);
    setIsOptionsUpdated(true);
}
  }, [simObj?.lastSixMonthsDemands,simObj?.optionsAvailable,isOptionsUpdated]);

  useEffect(()=>{
    if(simObj?.currentstep){
      setIsOptionsUpdated(false);
    }
  },[simObj?.currentstep])
  const getShortMonth = (month) => {
    let months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"]
    return months[month - 1];
  }
  function transformKeys(obj) {
    return Object.keys(obj).reduce((acc, key) => {
      // Call your function here and assign the result to the new key
      const newKey = getShortMonth(key);

      // Use the spread operator to copy the rest of the object
      acc[newKey] = obj[key];
      return acc;
    }, {});
  }
  useEffect(() => {
    if (isResult && chart != undefined) {
      chart?.series[0]?.setData([]);
      chart?.series[1]?.setData([]);
      setSimObj((prevObj) => ({
        ...prevObj,
        graphdata: summaryGraphData,
      }));
    }
    else {
      //setGraphData();
      if (chart != undefined) {
        let LastSixMonths = simObj?.lastSixMonthsDemands;
        LastSixMonths = (LastSixMonths != undefined ? LastSixMonths : []).map(transformKeys);
        //console.log(LastSixMonths.map(entry => Object.keys(entry)[0]));
        const newMonths = LastSixMonths?.map(entry => Object.keys(entry)[0]);

        // Update the x-axis categories
        if (chart && chart.xAxis && chart.xAxis[0]) {
          chart.xAxis[0].setCategories([...newMonths], true);
        }
      }
    }
    if (chart != undefined) {
      setRevenueGraphLabel(`Revenue and Cost of quality graph representing along Y-axis with ${chart?.yAxis != undefined && chart?.yAxis[0].tickInterval} per unit scale and Time quarter along X-axis with 1 quarter per unit scale.`);
      document.querySelector("#ActualDemandGraph").setAttribute('role', `figure`);
      document.querySelector("#ActualDemandGraph .highcharts-container ").setAttribute('tabindex', '0');
      document.querySelector("#ActualDemandGraph .highcharts-container ").style.width = "561px";
    }
  }, [chart, simObj?.laststate?.graphdata, simObj?.currentstep, summaryGraphData]);
  useEffect(() => {
    if (isResult) {
      //setGraphData();
    }
  }, [simObj, isResult, summaryGraphData])


  return (
    <div className={`${FcModuleStyle['graph-container-actualDemand']}`}>
      {/* {!simObj?.graphdata?.length && <div className={`${FcModuleStyle['nodata-alert-revenue']}`}>Cost of quality will appear here as the simulation runs</div>} */}
      <span></span>
      {/* <a href="#" onClick={(e) => e.preventDefault()} aria-label="Legends: line with round bullet for Revenue and line with Rhombus got Cost of Quality" className="sr-only"></a> */}
      <div id="ActualDemandGraph" className={`${FcModuleStyle['revenue-graph']}`} aria-label={revenueGraphLabel} role='figure'>
      </div>
    </div>
  )
}

export default ActualDemandGraph